import React from 'react';
import PropTypes from 'prop-types';
import Datetime from 'react-datetime';
import { isMoment } from 'moment';
import { setComponentError } from '../../utils/component_error_rule';
import moment from 'moment';
import UiComponent from '../UiComponent';
import {getCurrentTimeZone} from "../../utils/date";
export const defaultDateFormat = 'MM-DD-YYYY';

export default class DatePicker extends UiComponent {

  constructor(props) {
    super(props);
    this.state = {
      isValid: true,
      useLocalTimeZone: props.useLocalTimeZone !== undefined ? props.useLocalTimeZone : false
    };
    this.changeValue = this.changeValue.bind(this);
    this.selectValue = this.selectValue.bind(this);
  }

  changeValue(value) {
    const field = this.props.field;
    let mVal = moment.utc(value, field.dateFormat, true);
    const isValid = mVal.isValid();

    setComponentError(field, !value || isValid
      ? null
      : (field.dateFormat
        ? `Invalid date. Please, make sure the date is in a format ${field.dateFormat}`
        : 'Invalid date'));

    this.setState({isValid: isValid});
    field.value = isValid ? mVal._d : value;

    if (this.props.relatedTo && this.props.relatedTo.length > 0) {
      this.props.onChange([
          this.props.relatedTo,
          field.name,
        ],
        field
      );
    } else {
      this.props.onChange(field.name, field);
    }
  }

  selectValue(value) {
    if (isMoment(value)) {
      const field = this.props.field;
      const mVal = moment.utc(value, field.dateFormat, true);
      field.value = mVal._d;
      if (this.props.relatedTo && this.props.relatedTo.length > 0) {
        this.props.onChange([
            this.props.relatedTo,
            field.name,
          ],
          field
        );
      } else {
        this.props.onChange(field.name, field);
      }
      this.setState({isValid: true});
    }
  }

  render() {
    const field = this.props.field || {};
    const containerClass = `form-group ${this.props.className}`;
    const inputProps = {
      disabled: this.props.disabled,
      placeholder: field.placeholder
    };

    const isInput = !field.input;

    return (
      <div className={containerClass}>
        {this.getLabel()}
        <Datetime
          isValidDate={field.isValidDate}
          value={this.state.isValid && field.value ? new Date(field.value) : field.value}
          dateFormat={field.dateFormat}
          timeFormat={field.timeFormat}
          open={field.open}
          input={field.input}
          viewMode={field.viewMode}
          onChange={isInput ? this.selectValue : this.changeValue}
          onBlur={isInput ? this.changeValue : undefined}
          inputProps={inputProps}
          utc={field.utc}
          displayTimeZone={this.state.useLocalTimeZone ? getCurrentTimeZone() : undefined}
        />
        {this.getErrors()}
      </div>
    );
  }
}

DatePicker.propTypes = {
  className: PropTypes.string,
  field: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/common/DatePicker/index.js